import { InfosetsGuard } from '@/modules/infosets/guards/Infosets.guard';
export const InfosetsRouter = [
    {
        path: '/',
        component: () => import('pages/Infosets.vue'),
        beforeEnter: InfosetsGuard.all,
        name: 'infosets',
    },
    {
        path: '/infosets/:infosetId',
        name: 'infoset',
        component: () => import('pages/Infoset.vue'),
        beforeEnter: InfosetsGuard.byId,
        children: [
            {
                path: 'companies/:companyId',
                name: 'infoset_company',
                beforeEnter: InfosetsGuard.byCompanyId,
            },
        ],
    },
    // {
    //   path: '/infosets/:infoSetId/llm/by-decisor',
    //   name: 'infoset',
    //   component: () => import('pages/DecisorListLLM.vue'),
    //   beforeEnter: InfosetsGuard.byId,
    // },
    // {
    //   path: '/infosets/:infoSetId/old/llm/by-company',
    //   name: 'infoset',
    //   component: () => import('pages/CompanyListLLM.vue'),
    //   beforeEnter: InfosetsGuard.byId,
    // },
    {
        path: '/infosets/:infoSetId/llm/:channel',
        name: 'llm',
        component: () => import('pages/llm.vue'),
        beforeEnter: InfosetsGuard.byId,
    },
];
